// extracted by mini-css-extract-plugin
export var errorBanner = "_da-2";
export var scroller = "_da-0";
export var thinking = "_da-1";
export var visuallyHidden = "_da-3";